import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";
import { IProviderData } from "@/types/provider";
import { useProvidersColumns } from "@/pages/providers/hooks/use-columns";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { DataTable } from "@/components/refine-ui/data-table/data-table";

export const ProvidersList = () => {
  const defaultQueryBy = "provider";

  const columns = useProvidersColumns();

  const table = useTable<IProviderData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      meta: {
        defaultQueryBy: defaultQueryBy,
      },
      sorters: {
        initial: [
          {
            field: "createdAt",
            order: "desc",
          },
        ],
      },
      pagination: {
        pageSize: 25,
      },
    },
    meta: {
      querySuggestions: [
        {
          id: "name",
          label: "name",
        },
      ],
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="providers" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
